import _ from "lodash";
import { callPutApi } from "./Api";

let interval = null;

const loggingApi = (url, actionBody, token) => {
    callPutApi(url, actionBody, token);
}

const loggingFunc = (viewId, userId, loggingKey, playerObj, userNo, token) => {
    const loggingTime = new Date();
    const loggingDate = dateFormat(loggingTime);

    const loggingBody = {
        systemId: "digest",
        userId: userId,
        userNo: userNo,
        action: "interval",
        actionData: JSON.stringify(playerObj),
        viewId: viewId,
        loggingDate,
        loggingTime: loggingTime.getTime(),
        loggingKey: loggingKey.getTime()
    };

    loggingApi("/api/intervalLogger", loggingBody, token);
}

function dateFormat(date) {
    const loggingDate =
        date.getFullYear() +
        "-" +
        numformat(date.getMonth() + 1) +
        "-" +
        numformat(date.getDate());

    return loggingDate;
}

const numformat = (num) => {
    let formattedNum = "";
    if (num < 10) formattedNum = "0" + num;
    else formattedNum = "" + num;

    return formattedNum;
};


function intervalLogging(viewId, token, playerObj) {
    const loggingKey = new Date();
    if(token) {
        let userId = token.accessUserId;
        let userNo = token.userNo;
        loggingFunc(viewId, userId, loggingKey, playerObj, userNo, token);
        interval = setInterval(
            () => loggingFunc(viewId, userId, loggingKey, playerObj, userNo, token),
            30000
        );
    }
}

function stopLogging() {
    if (interval) clearInterval(interval);
}

export {intervalLogging, stopLogging};